<template>
  <div class="relative">
    <input
      type="text"
      class="w-full border px-4 py-2 rounded-full pl-10 shadow-primary"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :placeholder="placeholder"
      @keydown.enter="confirmSearch"
    />

    <svg
      class="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35"
      />
    </svg>

    <button
      class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-primary-500 text-white px-3 py-1 rounded-full text-xs hover:bg-primary-600 button-interactive"
      @click.prevent="confirmSearch"
    >
      Confirmar
    </button>

    <button
      v-if="modelValue"
      class="system-button absolute top-1.5"
      @click="clearSearch"
    >
      <close-icon class="w-8 fill-current" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: String,
  },
  methods: {
    clearSearch() {
      this.$emit("update:modelValue", "");
      this.$emit("clear");
    },

    confirmSearch() {
      this.$emit("confirm", this.modelValue);
    },
  },
};
</script>

<style scoped>
input {
  padding-left: 2.5rem;
}
</style>
